import React, { Fragment } from 'react'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { Link, NavLink } from 'react-router-dom'

const authenticatedOptions = (
  <Fragment>
    <NavLink to='/change-password' className='nav-link'>
        Change Password
    </NavLink>
    <NavLink to='/sign-out' className='nav-link'>
        Sign Out
    </NavLink>
    <NavLink
      to='/create-list'
      className='nav-link'
      style={{ color: '#eb144c', textDecoration: 'none' }}>
        Create List
    </NavLink>
    <NavLink
      to='/lists'
      className='nav-link'
      style={{ color: '#eb144c', textDecoration: 'none' }}>
        My List
    </NavLink>
  </Fragment>
)

const unauthenticatedOptions = (
  <Fragment>
    <NavLink to='/sign-up' className='nav-link'>Sign Up</NavLink>
    <NavLink to='/sign-in' className='nav-link'>Sign In</NavLink>
  </Fragment>
)

const Header = ({ user }) => (
  <Navbar useTransparent variant='dark' expand='md'>
    <Navbar.Brand>
      <Link to='/' style={{ color: '#eb144c', textDecoration: 'none' }}>
          H.U.W
      </Link>
    </Navbar.Brand>
    <Navbar.Toggle aria-controls='basic-navbar-nav' />
    <Navbar.Collapse id='basic-navbar-nav'>
      <Nav className='ml-auto'>
        {user && (
          <span className='navbar-text mr-2'>Welcome, {user.email}</span>
        )}
        {user ? authenticatedOptions : unauthenticatedOptions}
      </Nav>
    </Navbar.Collapse>
  </Navbar>
)

export default Header
